import { useQuery } from 'convex/react';

import { api } from '../../convex/_generated/api';

export default function Standings() {
  const currentSeason = useQuery(api.seasons.getCurrent);
  const rows = useQuery(
    api.standings.getStandings,
    currentSeason ? { season: currentSeason.year } : 'skip',
  );

  if (!currentSeason || !rows) return <div className="p-4">Loading…</div>;

  const east = rows.filter((r) => r.division === 'East');
  const west = rows.filter((r) => r.division === 'West');

  function Table({ title, rows }: { title: string; rows: typeof east }) {
    return (
      <section className="mb-6">
        <h2 className="font-semibold mb-2">{title}</h2>
        <table className="w-full text-sm">
          <thead>
            <tr className="border-b text-left">
              <th className="py-1">Franchise</th>
              <th>W</th>
              <th>L</th>
              <th>T</th>
              <th>GB</th>
              <th>Streak</th>
              <th>PF</th>
              <th>PA</th>
            </tr>
          </thead>
          <tbody>
            {rows.map((r) => (
              <tr key={r.franchiseId} className="border-b">
                <td className="py-1">{r.name}</td>
                <td>{r.wins}</td>
                <td>{r.losses}</td>
                <td>{r.ties}</td>
                <td>{r.gamesBack === 0 ? '-' : r.gamesBack.toFixed(1)}</td>
                <td>{r.streak}</td>
                <td>{r.pointsFor.toFixed(2)}</td>
                <td>{r.pointsAgainst.toFixed(2)}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </section>
    );
  }

  return (
    <div className="p-4 max-w-4xl mx-auto">
      <h1 className="text-2xl font-bold mb-4">{currentSeason.year} Standings</h1>
      <Table title="East" rows={east} />
      <Table title="West" rows={west} />
    </div>
  );
}
